/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { DataAssetApiService } from './services/DataAssetApiService';
import { StorageApiService } from './services/StorageApiService';
import { TemplatesApiService } from './services/TemplatesApiService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

/**
 * Deprecated remnant of the docker-generated dotnet client. Retained only for the
 * legacy Unity app shell (`ux/ActivityLog`, `ux/DataAssetLog`, `ui-legacy/Field`),
 * which still consume `dataAssetApi`, `storageApi`, and `templatesApi`. Prefer the
 * regenerated client at `src/api` (via `useRestClient()`) for any new work.
 */
export class DMPClient {

    public readonly dataAssetApi: DataAssetApiService;
    public readonly storageApi: StorageApiService;
    public readonly templatesApi: TemplatesApiService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.dataAssetApi = new DataAssetApiService(this.request);
        this.storageApi = new StorageApiService(this.request);
        this.templatesApi = new TemplatesApiService(this.request);
    }
}
